export default __webpack_public_path__ + "static/media/resume.419ac10a.svg";